import { InjectionToken } from '@angular/core';
import { MetadataStore } from 'breeze-client';

export type BreezeEntityRegistryFunc = (metadataStore: MetadataStore) => void;

export const BREEZE_METADATA_TOKEN: InjectionToken<object> = new InjectionToken<object>('BREEZE_METADATA_TOKEN');
export const BREEZE_ENTITY_REGISTRATION_FUNC: InjectionToken<BreezeEntityRegistryFunc> =
  new InjectionToken<BreezeEntityRegistryFunc>('BREEZE_ENTITY_REGISTRATION_FUNC');
